"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { sanitizePathnameForTelemetry } from "@/lib/axiom/path";
import { useSafeNextAxiomLogger } from "@/lib/axiom/use-next-axiom-logger";

const CLIENT_TELEMETRY_BASE_FIELDS = {
  source: "handled-platform-app-client",
  runtime: "browser",
};

/**
 * Emits a one-time browser telemetry readiness signal with only operational,
 * non-identifying fields. The route is app-sanitized before it reaches the
 * next-axiom client logger so query strings and dynamic IDs are never sent.
 */
export function AxiomClientTelemetry() {
  const pathname = usePathname();
  const route = sanitizePathnameForTelemetry(pathname);
  const logger = useSafeNextAxiomLogger(CLIENT_TELEMETRY_BASE_FIELDS);
  const hasLogged = useRef(false);

  useEffect(() => {
    if (hasLogged.current) return;
    hasLogged.current = true;
    logger.info("client telemetry ready", {
      route,
    });
  }, [logger, route]);

  return null;
}
